// extracted by mini-css-extract-plugin
export default {"outerDiv":"sec-card_outerDiv__AdkVN"};